const validate = values => {
  const errors = {}
  
  if (values.password !== values.password2) {
    errors.password2 = 'New passwords do not match'
    errors.password = 'New passwords do not match'
  }
  if (!values.email) {
    errors.email = 'Required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  return errors
}

export default validate